import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './customer.reducer';

export const CustomerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const customerEntity = useAppSelector(state => state.customer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="customerDetailsHeading">
          <Translate contentKey="tycheApp.customer.detail.title">Customer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.customer.id">Id</Translate>
            </span>
          </dt>
          <dd>{customerEntity.id}</dd>
          <dt>
            <span id="userId">
              <Translate contentKey="tycheApp.customer.userId">User Id</Translate>
            </span>
          </dt>
          <dd>{customerEntity.userId}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tycheApp.customer.name">Name</Translate>
            </span>
          </dt>
          <dd>{customerEntity.name}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tycheApp.customer.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{customerEntity.gender}</dd>
          <dt>
            <span id="birthDate">
              <Translate contentKey="tycheApp.customer.birthDate">Birth Date</Translate>
            </span>
          </dt>
          <dd>
            {customerEntity.birthDate ? <TextFormat value={customerEntity.birthDate} type="date" format={APP_LOCAL_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="age">
              <Translate contentKey="tycheApp.customer.age">Age</Translate>
            </span>
          </dt>
          <dd>{customerEntity.age}</dd>
          <dt>
            <span id="phoneNumber">
              <Translate contentKey="tycheApp.customer.phoneNumber">Phone Number</Translate>
            </span>
          </dt>
          <dd>{customerEntity.phoneNumber}</dd>
          <dt>
            <span id="icNumber">
              <Translate contentKey="tycheApp.customer.icNumber">Ic Number</Translate>
            </span>
          </dt>
          <dd>{customerEntity.icNumber}</dd>
          <dt>
            <span id="joinDate">
              <Translate contentKey="tycheApp.customer.joinDate">Join Date</Translate>
            </span>
          </dt>
          <dd>{customerEntity.joinDate ? <TextFormat value={customerEntity.joinDate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <Translate contentKey="tycheApp.customer.publisher">Publisher</Translate>
          </dt>
          <dd>{customerEntity.publisher ? customerEntity.publisher.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/customer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/customer/${customerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CustomerDetail;
